module.exports = __webpack_public_path__ + "img/leganes-logo-icon.abfb0175.png";